// import TestManager from '@/layouts/test-manager/test-manager.vue'
// import StendPage from '@/pages/stend/stend-page.vue'
import StendPage from '@/pages/stend/stend-page.vue'
import { RouteRecordRaw } from 'vue-router'

// const ChangePasswordPage = () => import('../../pages/auth-сhange-password/сhange-password.vue')
// const EmptyLayout = () => import('../../widgets/layout/ui/empty-layout/empty-layout.vue')
const ProjectsPage = () => import('@/pages/projects/projects-page.vue')
const ProjectPage = () => import('@/pages/projects/project-page.vue')
const ProjectTestPage = () => import('@/pages/projects/project-test-page.vue')
const HistoryPage = () => import('@/pages/history/history-page.vue')
const HistoryDetalePage = () =>
  import('@/pages/history/history-detale-page.vue')
const TestPage = () => import('@/pages/tests/tests-page.vue')
const ScenarioPage = () => import('@/pages/scenario/scenario-page.vue')

/**Маршруты проекта */
const testManagerRoutes: RouteRecordRaw[] = [
  // {
  //   name: '/test-manager',
  //   path: 'test-manager',
  //   component: ProjectsPage,
  //   meta: {
  //     title: 'Работа с проектами',
  //   },

  // },
  {
    name: 'test-manager-projects',
    path: 'projects',
    component: ProjectsPage,
    meta: {
      title: 'Работа с проектами',
      isAuth: true,
      roles: [],
    },
  },
  {
    name: 'test-manager-project',
    path: 'project/:projectId',

    component: ProjectPage,
    meta: {
      title: 'Работа с тестами проекта',
      hidden: true,
      roles: [],
    },
  },
  {
    name: 'test-manager-tests',
    path: 'project/:projectId/tests',
    component: ProjectTestPage,
    meta: {
      title: 'Работа с тестом',
      hidden: true,
    },
  },
  {
    name: 'test-manager-scenario',
    path: 'project/:projectId/scenario/:scenarioId',
    component: ScenarioPage,
    meta: {
      title: 'Сценарий теста',
      hidden: true,
    },
  },

  // {
  //   name: 'test-manager-history-list',
  //   path: 'history',
  //   component: HistoryPage,
  //   meta: {
  //     title: 'История тестирования',
  //   },
  // },
  // {
  //   name: "test-manager-history-list",
  //   path: "history/:projectId",
  //   component: HistoryPage,
  //   meta: {
  //     title: "История тестирования",
  //   },
  // },
  {
    name: 'test-manager-history-list',
    path: 'project/:projectId/history',
    component: HistoryPage,
    meta: {
      title: 'История тестирования',
    },
  },

  {
    name: 'test-manager-history-details',
    path: 'project/:projectId/history-details',
    component: HistoryDetalePage,
    meta: {
      title: 'История',
      hidden: true,
    },
  },

  {
    name: 'test-manager-test-list',
    path: 'project/:projectId/test',
    component: TestPage,
    meta: {
      title: 'Выполнить тестирование',
      hidden: true,
    },
  },

  {
    name: 'test-manager-stands',
    path: 'project/:projectId/stands',
    component: StendPage,
    meta: { title: 'Стенд', icon: 'mdi-equalizer' },
  },
]

export default testManagerRoutes
